import { SET_IS_IN_TEAMS } from '../actionConstants';

export const setIsInTeamsAction = (payload) => {
  return {
    type: SET_IS_IN_TEAMS,
    payload,
  };
};
